<template>
  <div>
    <div class="info">
      <h1>{{ $t('payroll_wage_19') }}</h1>
      <p>
        <!-- 记薪月份 -->
        <span>
          <label>{{ $t('398') }}：</label>
          {{ activeData.info.pay_month }}
        </span>
        <!-- 薪资周期 -->
        <span>
          <label>{{ $t('wage.1') }}：</label>
          {{ activeData.info.start_date }}
          {{ $t('409') }}
          {{ activeData.info.end_date }}
        </span>
        <!-- 考勤周期 -->
        <span>
          <label>{{ $t('wage.2') }}：</label>
          {{ activeData.info.att_start_date }}
          {{ $t('409') }}
          {{ activeData.info.att_end_date }}
        </span>
      </p>
    </div>
    <div class="content">
      <h1>{{ $t('payroll_wage_27') }}</h1>
      <div class="search">
        <div class="search-left">
          <el-input
            class="search-input"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
            prefix-icon="el-icon-search"
            size="small"
            clearable
            v-model="requestParams.search_word"
          >
          </el-input>
          <el-button size="small" type="primary" @click="payrollSubStaffList()">{{ $t('69') }}</el-button>
        </div>
        <div class="search-center"></div>
        <div class="search-right">
          <!-- 更多 -->
          <el-popover placement="bottom" width="220" trigger="click" class="some">
            <div>
              <div class="some-all">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{
                  $t('1005')
                }}</el-checkbox>
                <el-button size="small" type="text" @click="handleReset">{{ $t('work_rule_7') }}</el-button>
              </div>
              <div></div>
              <el-checkbox-group v-model="checkedColumn" @change="handleCheckedCitiesChange">
                <template v-for="item in columnInfo">
                  <el-checkbox
                    class="column-checkbox"
                    :key="item.type"
                    :label="item.type"
                    v-if="item.title !== 'common'"
                  >
                    {{ $t(item.title) }}
                  </el-checkbox>
                </template>
              </el-checkbox-group>
            </div>
            <img slot="reference" src="@/assets/img/icon-some.png" alt="" />
          </el-popover>
          <!-- 调整税额  预扣税不展示 -->
          <el-popover
            v-if="activeData.info.tax_deduction_status !== '4'"
            placement="bottom"
            width="220"
            trigger="hover"
            v-model="visibleTax"
          >
            <ul class="tax">
              <template v-for="(item, key) in taxAdjusted">
                <li v-if="key !== '0'" :key="item" @click="handleTax(key, item)" :class="{ active: key === taxModule }">
                  <el-tooltip
                    v-if="key === '1'"
                    class="item"
                    effect="dark"
                    :content="$t('payroll_wage_39')"
                    placement="top-start"
                  >
                    <span>{{ item }}</span>
                  </el-tooltip>
                  <span v-else>{{ item }}</span>
                </li>
              </template>
            </ul>
            <el-button class="tax-button" slot="reference" size="small">{{ taxAdjusted[taxModule] }}</el-button>
          </el-popover>
          <!-- 导入考勤 -->
          <el-button size="small" @click="handleKaoqinUploadClick">{{ $t('1004') }}</el-button>
          <!-- 同步考勤 -->
          <el-button size="small" :loading="generateLoad" @click="generateAttendance">{{ $t('1154') }}</el-button>
          <!--上传薪资导入项 -->
          <el-button size="small" @click="handleUploadClick" type="primary">{{ $t('payroll_wage_28') }}</el-button>
        </div>
      </div>
      <div class="wrap1-tip" v-if="activeData.info.settlement_type === '1'">
        <i class="el-icon-info icon-info"></i>
        <p>{{ $t('payroll_wage_41') }}</p>
        <template v-if="activeData.info.tax_deduction_status !== '4'">
          <p>{{ $t('payroll_wage_42') }}</p>
          <p>{{ $t('payroll_wage_43') }}</p>
          <p>{{ $t('payroll_wage_44') }}</p>
        </template>
      </div>
      <!-- 表格数据 -->
      <all-table
        :tableData="tableData.list"
        :tableCloumn="tableCloumns"
        :edit="checkedColumn.length === 1 && checkedColumn[0] === 'social_security' ? false : edit"
        :info="activeData.info"
        @handleEdit="handleEdit"
        @sort="handlerSort"
      />
    </div>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page.currentPage"
      :page-sizes="page.pageSizes"
      :page-size="page.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    />

    <!-- 上传薪资导入项 -->
    <uploadDialog
      ref="upload"
      action="web/payroll_rule/import_staff_excel"
      :importList="importList"
      :uploadData="{ sub_project_id: projectId }"
      :title="$t('14')"
      :resultParams="resultParams"
      :onSuccess="onSuccess"
    />
    <!-- 考勤导入 -->
    <uploadDialog
      ref="kaoqinUpload"
      action="/web/payroll_rule/import_attendance_excel"
      :importList="kaoqinImportList"
      :uploadData="{ sub_project_id: projectId }"
      :title="$t('14')"
      :onSuccess="onSuccess"
      :resultParams="{
        successName: 'success_num',
        errorNum: 'fail_num',
        allname: 'all_num'
      }"
    />
    <!-- 税额批量调整 -->
    <uploadDialog
      ref="taxUpload"
      action="/web/payroll_rule/import_tax_excel"
      :importList="taxImport"
      :uploadData="{ sub_project_id: projectId }"
      :title="$t('payroll_wage_38')"
      :onSuccess="onSuccess"
      @doSubmit="doSubmit"
      :resultParams="{
        successName: 'upload_success_count',
        errorNum: 'upload_fail_count',
        allname: 'upload_total_count'
      }"
    />
  </div>
</template>

<script>
import {
  generateAttendance,
  saveItemInfo,
  payrollSubStaffList,
  getListHeaderColumns,
  payrollKaoqinDownFn,
  downloadStaffPayInfoTplNew,
  exportTaxExcel, // 子项目-批量修改税-模版
  clearSalaryMonthTax // 子项目-清空所有员工的税
} from '@/api/payroll'
// 上传
import uploadDialog from '@/views/payroll/compontents/uploadSelf'
import Pagination from '@/components/pagination'
import allTable from './components/all-info'
import { info, allColumn, common, staff_info, NetPay } from './column.js'
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: { Pagination, uploadDialog, allTable },
  data() {
    return {
      projectId: this.$route.params.id,
      checkedColumn: allColumn,
      isIndeterminate: false,
      checkAll: true,
      columnInfo: info,
      currentColumn: [], // 表头
      tableData: {},
      edit: true,
      generateLoad: false,
      requestParams: {
        // 请求参数
        page: 1,
        page_size: 20,
        search_word: '',
        data_type: 'all' // tabs栏控制
      },
      page: {
        pageSizes: [20, 50, 100],
        total: 0,
        currentPage: 1
      },
      visible: false, // 编辑窗口展示
      sort: '',
      dir: '',
      importList: [], // 模版列表
      kaoqinImportList: [],
      taxImport: [],
      tableCloumns: [],
      visibleTax: false,
      taxModule: '0',
      taxAdjusted: {
        0: this.$t('payroll_wage_36'),
        1: this.$t('payroll_wage_37'),
        2: this.$t('payroll_wage_38')
      },
      resultParams: {
        allname: 'upload_total_count',
        successName: 'upload_success_count',
        errorNum: 'upload_fail_count'
      },
      cloneRow: {}
    }
  },
  mounted() {
    this.importList = [
      {
        name: this.$t('650'),
        method: () => this.download('month')
      }
    ]

    this.kaoqinImportList = [
      {
        name: this.$t('650'),
        method: () => this.kaoqinDownload()
      }
    ]

    this.taxImport = [
      {
        name: this.$t('650'),
        method: () => this.taxDownload()
      }
    ]
  },
  created() {
    this.init()
  },
  watch: {
    tableData: {
      handler(val) {
        this.$emit('changeList', val.list)
      },
      deep: true,
      immediate: true
    },
    currentColumn: {
      handler(v) {
        // this.activeData.info.settlement_type 1月结 2日结 3其他 99其他
        this.tableCloumns = v.filter(item =>
          item.isShow ? item.isShow.includes(Number(this.activeData.info.settlement_type)) : true
        )
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    init() {
      this.payrollSubStaffList() // 获取表格列表信息
      this.loadSubStaffColumns()
    },
    get_income_type_column() {
      const res = []
      if (+this.activeData?.info.tax_deduction_status === 4) {
        res.push({
          label: this.$t('1980'),
          prop: 'income_type',
          // 1月结 2日结
          isShow: [1, 2],
          align: 'left',
          width: '200px'
        })
      }
      return res
    },
    loadSubStaffColumns() {
      this.currentColumn = []
      const query = this.checkAll ? ['all'] : this.checkedColumn
      if (!this.isIndeterminate && !this.checkAll) {
        this.currentColumn = [...common]
        this.currentColumn[0].width = 'auto'
        this.edit = false
        return
      }
      getListHeaderColumns({
        sub_project_id: this.projectId,
        active: 2,
        data_type: query
      }).then(res => {
        this.currentColumn = []
        if (this.checkAll) {
          this.currentColumn = [...common, ...staff_info, ...this.get_income_type_column(), ...res.data, ...NetPay]
        } else {
          if (this.checkedColumn.includes('staff_info')) {
            this.currentColumn = [...common, ...staff_info, ...this.get_income_type_column(), ...res.data, ...NetPay]
          } else {
            this.currentColumn = [...common, ...res.data, ...NetPay]
          }
        }
        this.currentColumn[0].width = '264'
        this.edit = true
        if (this.currentColumn.length === 2) {
          this.currentColumn[0].width = 'auto'
        }
      })
    },
    handleCheckAllChange(val) {
      // 全量信息
      this.checkedColumn = val ? allColumn : []
      this.isIndeterminate = false
      this.loadSubStaffColumns()
    },
    handleCheckedCitiesChange(value) {
      // 选择展示表格内容
      const checkedCount = value.length
      const len = Object.keys(this.columnInfo).length
      this.checkAll = checkedCount === len
      this.isIndeterminate = checkedCount > 0 && checkedCount < len
      this.loadSubStaffColumns()
    },
    handleReset() {
      // 重置
      this.checkedColumn = []
      this.handleCheckedCitiesChange(this.checkedColumn)
    },
    async payrollSubStaffList() {
      // 请求列表数据
      const msg = {
        sort: this.sort, // 排序相关
        dir: this.dir,
        ...this.requestParams,
        sub_project_id: this.projectId
      }
      const res = await payrollSubStaffList(msg)
      const data = res.data
      this.tableData = res.data
      this.page.total = data.count
    },
    handlerSort({ prop, order }) {
      // 排序
      this.sort = prop
      this.dir = order
      this.payrollSubStaffList()
    },
    handleCurrentChange(val) {
      this.requestParams.page = val
      this.payrollSubStaffList()
    },
    handleSizeChange(val) {
      this.requestParams.page = 1
      this.requestParams.page_size = val
      this.payrollSubStaffList()
    },
    async handleEdit(row, status, scope, save) {
      // 子组件 编辑 取消 保存
      /**
       *  参数说明
       *  row 当前行  status编辑状态 scope 表格当前行对象 save 是否存储
       */
      if (!save && !status) {
        // 取消
        row = JSON.parse(JSON.stringify(this.cloneRow.children))
      } else if (save && !status) {
        delete row.children
        const msg = {
          sub_project_id: this.projectId,
          staff_id: row.staff_info_id,
          list: row
        }
        // 保存操作
        const res = await saveItemInfo(msg)
        row = res.data.list
      } else {
        const r = JSON.parse(JSON.stringify(row))
        // 开启编辑
        this.$set(this, 'cloneRow', { ...r, children: r })
        const data = JSON.parse(JSON.stringify(row))
        this.tableCloumns.forEach(item => {
          if (item.edit) {
            // const str = String(data[item.prop]).replace(/,/gi, '')
            // const num = Number(str)
            // data[item.prop] = isNaN(num) ? '' : num
            const str = String(data[item.prop]).replace(/,/gi, '')
            // const num = Number(str)
            data[item.prop] = isNaN(str) ? '' : str
          }
        })
        data.children = JSON.parse(JSON.stringify(data))
        row = data
      }
      row.edit = status
      this.$set(this.tableData.list, scope.$index, row)
    },
    // 模版上传成功回掉
    onSuccess(res) {
      if (res.code === 0) {
        this.$notify({
          title: this.$t('229'),
          message: res.message,
          type: 'warning'
        })
        return false
      }
      if (res.data && res.data.object_url) window.location.href = res.data.object_url
      if (res.data && res.data.feedback_file_url) window.location.href = res.data.feedback_file_url
      this.payrollSubStaffList()
    },
    // 上传组件展示
    handleUploadClick() {
      // 上传薪资导入项
      this.$refs.upload.init()
    },
    async download() {
      // 上传薪资导入项 模版下载
      const res = await downloadStaffPayInfoTplNew({ sub_project_id: this.projectId })
      if (res.data && res.data.object_url) window.location.href = res.data.object_url
    },
    async kaoqinDownload() {
      // 考勤导入模版下载
      const res = await payrollKaoqinDownFn({ sub_project_id: this.projectId })
      if (res.data && res.data.object_url) window.location.href = res.data.object_url
    },
    async taxDownload() {
      // 子项目-批量修改税-模版
      const res = await exportTaxExcel({ sub_project_id: this.projectId })
      if (res.data && res.data.url) window.location.href = res.data.url
    },
    handleTax(key, item) {
      // 调整税额
      if (this.taxModule !== key) this.taxModule = key
      this.visibleTax = false
      if (key === '1') {
        // 清空税额
        this.$confirm(this.$t('payroll_wage_40'), '', {
          confirmButtonText: this.$t('submit_btn'),
          cancelButtonText: this.$t('cancel_btn'),
          type: 'warning'
        })
          .then(() => {
            clearSalaryMonthTax({ sub_project_id: this.projectId }).then(res => {
              if (res.code === 1 && res.data) {
                this.$message.success(res.message)
                this.payrollSubStaffList()
              }
            })
          })
          .catch(() => {
            this.taxModule = '0'
          })
      } else {
        // 批量调整
        this.$refs.taxUpload.init()
      }
    },
    doSubmit() {
      this.taxModule = '0'
    },
    handleKaoqinUploadClick() {
      // 导入考勤
      this.$refs.kaoqinUpload.init()
    },
    generateAttendance() {
      // 同步考勤
      this.generateLoad = true
      generateAttendance({ sub_project_id: this.projectId })
        .then(res => {
          if (res && res.code === 1) {
            this.payrollSubStaffList()
            this.$notify({
              title: this.$t('818'),
              message: this.$t('886'),
              type: 'success'
            })
          }
        })
        .finally(() => {
          this.generateLoad = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 16px;
  color: #262626;
  margin: 0;
  padding-bottom: 16px;
}
.info {
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f0;
  p {
    display: flex;
    flex-wrap: wrap;
    span {
      flex: 1;
      font-size: 14px;
      color: #595959;
      label {
        color: #262626;
      }
    }
  }
}
.content {
  padding-top: 24px;
  padding-bottom: 15px;
  .search {
    display: flex;
    flex-wrap: wrap;
    .search-center {
      flex: 1;
    }
    .search-left {
      padding-bottom: 16px;
      .screen {
        /deep/ span {
          display: flex;
          align-items: center;
        }
        img {
          width: 16px;
          margin-left: 4px;
        }
      }
    }
    .search-right {
      padding-bottom: 16px;
      .some {
        img {
          width: 32px;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .el-select {
        margin-left: 16px;
        max-width: 150px;
      }
      .el-button {
        margin-left: 16px;
      }
    }
    .search-input {
      min-width: 320px;
      margin: 0 16px;
    }
  }
}
.some-all {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .el-checkbox {
    display: block;
  }
  padding-bottom: 13px;
  border-bottom: 1px solid #f0f0f0;
}
.column-checkbox {
  padding-left: 3px;
  display: block;
  height: 34px;
  line-height: 34px;
}

.tax {
  li {
    padding: 0 10px;
    line-height: 34px;
    color: #262626;
    cursor: pointer;
    &:hover {
      background: #f5f7fa;
    }
    &.active {
      background: #f5f7fa;
      color: #5D51DA;
    }
  }
}
</style>
